
































































































































































































































































































































































































































import { Component, Prop, Watch, Vue } from "@/shared/vuepack";
import {
  UploadStatus,
  ContributionUploadedFile,
  FileUploadProcessingRule
} from "@/employer/types";
import { Location } from "vue-router";
import { formatCurrency } from "@/shared/currency";
import { getSortAttributeValue } from "@/shared/sorting";
import Pill from "@/shared/components/ui/Pill.vue";
import ManageFundingFile from "@/employer/components/shared/ManageFundingFile.vue";
import _ from "lodash";
import ContributionsNavigation from "@/employer/components/profile/ContributionsNavigation.vue";
import GuidelinesModal from "@/employer/components/contributions/GuidelinesModal.vue";
import Button from "@/shared/components/ui/Button.vue";
import Pagination from "@/shared/components/ui/Pagination.vue";
import PageSizeSelectList from "@/shared/components/ui/PageSizeSelectList.vue";
import HowItWorksWidget from "@/employer/components/shared/HowItWorksWidget.vue";
import moment from "moment";
import { useContributionUploadedFileStore } from "@/employer/store/contributionUploadedFile";
import { useFileProcessorSettingsStore } from "@/shared/store/fileProcessorSettings";
import { useEmployerPayrollStore } from "@/employer/store/employerPayroll";
import { useThemeStore } from "@/shared/store/theme";
import { useUserStore } from "@/shared/store/user";

@Component({
  components: {
    Pill,
    ManageFundingFile,
    ContributionsNavigation,
    Button,
    Pagination,
    PageSizeSelectList,
    GuidelinesModal,
    HowItWorksWidget
  }
})
export default class ContributionsFileUpload extends Vue {

  contributionUploadedFileStore = useContributionUploadedFileStore();
  fileProcessorSettingsStore = useFileProcessorSettingsStore();
  employerPayrollStore = useEmployerPayrollStore();
  userStore = useUserStore();
  themeStore = useThemeStore();

  @Prop()
  page: number;

  @Prop()
  routeToManagePayrollFundingFile: (page: number) => Location;

  @Prop({ required: false })
  hideHeader: boolean;

  @Prop({ required: false })
  payrollHistoryView: boolean;

  formatCurrency = formatCurrency;
  UploadStatus = UploadStatus;
  selectedActionPanelFileId = null;
  showConfirmModal = false;
  cancelFundingId = null;
  sortBy = "uploadDate";
  sortDesc = true;

  mounted (): void {
    this.contributionUploadedFileStore.loadFileList({
      employerId: this.userStore.employerId,
      pageNumber: this.page,
      sortOrder: this.sortOrder
    });
    this.fileProcessorSettingsStore.getFileProcessorSettings(this.userStore.employerId);
    this.$on("refreshFileUpload", () => {
      this.$router.push(this.routeToManagePayrollFundingFile(1));
      this.contributionUploadedFileStore.reloadFileList({
        employerId: this.userStore.employerId,
        sortOrder: this.sortOrder
      });
      this.closeActionsPanel();
    });
  }

  selectFile (event, file: ContributionUploadedFile): void {
    event.preventDefault();
    this.contributionUploadedFileStore.loadFileDetails({ file, employerId: this.userStore.employerId });
    this.closeActionsPanel();
  }

  downloadFundingFileSummaryCsv (event, id: number): void {
    event.preventDefault();
    this.contributionUploadedFileStore.downloadFundingFileSummary({ employerId: this.userStore.employerId, id });
    this.closeActionsPanel();
  }

  cancelProcessing (id: number): void {
    this.contributionUploadedFileStore.cancelFileProcessing({ employerId: this.userStore.employerId, id })
      .then(result => {
        this.cancelFundingId = null;
      })
      .finally(() => {
        this.hideModalAndStopCancel();
      });
  }

  openActionsPanel (event, file: ContributionUploadedFile): void {
    event.preventDefault();

    // if the panel is already selected, close the panel
    // if the file has successfully processed, allow download option
    // otherwise select the file to display the summary
    if (file.id === this.selectedActionPanelFileId) {
      this.closeActionsPanel();
    } else if (file.status === UploadStatus.Success || file.status === UploadStatus.PartialSuccess ||
      file.status === UploadStatus.Fail || file.status === UploadStatus.Rejected) {
      this.selectedActionPanelFileId = file.id;
    } else {
      this.selectFile(event, file);
    }
  }

  closeActionsPanel (): void {
    this.selectedActionPanelFileId = null;
  }

  anyProcessing (): boolean {
    if (this.contributionUploadedFileStore.fileListLoaded === false) {
      return false;
    }
    let hasProcessingStatusFile = false;
    _.forEach(this.contributionUploadedFileStore.contributionsForPage, (file: ContributionUploadedFile) => {
      if (file.status === UploadStatus.Processing) {
        hasProcessingStatusFile = true;
        return;
      }
    });
    return hasProcessingStatusFile;
  }

  get isUploadDisabled () {
    return this.anyProcessing() || this.contributionUploadedFileStore.shouldDisableUpload;
  }

  getPillClass (status: UploadStatus): string {
    switch (status) {
      case UploadStatus.Processing: {
        return "neutral-pill";
      }
      case UploadStatus.Fail: {
        return "error-pill";
      }
      case UploadStatus.Cancelled: {
        return "error-pill";
      }
      case UploadStatus.Rejected: {
        return "error-pill";
      }
      case UploadStatus.PartialSuccess: {
        return "warning-pill";
      }
      default: {
        return "success-pill";
      }
    }
  }

  toggleHowItWorks (): void {
    const currentValue = !this.contributionUploadedFileStore.showHowItWorks;
    this.contributionUploadedFileStore.setShowHowItWorks(currentValue);
  }

  getStatusText (status: UploadStatus): string {
    if (status === UploadStatus.PartialSuccess) {
      return "Partial Success";
    }
    return status;
  }

  switchPageSize (): void {
    // on switching page size, reset to page 1
    this.$router.push(this.routeToManagePayrollFundingFile(1));
    this.contributionUploadedFileStore.reloadFileList({
      employerId: this.userStore.employerId,
      sortOrder: this.sortOrder
    });
  }

  switchPage (toPage): void {
    this.$router.push(this.routeToManagePayrollFundingFile(toPage));
  }

  @Watch("page")
  onRouteValuePageNumberChanged (): void {
    this.contributionUploadedFileStore.loadFileList({
      employerId: this.userStore.employerId,
      pageNumber: this.page,
      sortOrder: this.sortOrder
    });
  }

  get displayOverrideSettingMessage (): boolean {
    return this.fileProcessorSettingsStore.fileUploadProcessingRule === FileUploadProcessingRule.override;
  }

  get displayMultipleFilesSettingMessage (): boolean {
    return this.fileProcessorSettingsStore.fileUploadProcessingRule === FileUploadProcessingRule.multipleFiles;
  }

  get displayFileSummaryPanel (): boolean {
    return this.contributionUploadedFileStore.selectedFileDetails &&
      this.contributionUploadedFileStore.fileDetailsLoaded;
  }

  get selectedPanelBorderClass (): string {
    return this.displayFileSummaryPanel ? "selected-panel-border" : "";
  }

  get sortOrder (): string {
    return `${this.sortBy}${this.sortDesc ? "_desc" : ""}`;
  }

  showFileSummary (status: UploadStatus): boolean {
    return status === UploadStatus.Success || status === UploadStatus.PartialSuccess
      || status === UploadStatus.Cancelled || status === UploadStatus.Rejected;
  }

  get fileSubmitCutoffHour () {
    const now = moment();
    let utc17 = moment.utc([now.year(), now.month(), now.day(), 17]);

    if (now.isAfter(utc17)) {
      // go to tomorrow
      utc17 = utc17.add(1, "days");
    }

    return utc17.isDST() ? "1" : "12";
  }

  onClose (e) {
    this.hideModalAndStopCancel();
  }

  hideModalAndStopCancel () {
    this.showConfirmModal = false;
    this.cancelFundingId = null;
  }

  confirmCancelModal () {
    this.cancelProcessing(this.cancelFundingId);
  }

  cancelRequest (event, id: number) {
    event.preventDefault();
    this.cancelFundingId = id;
    this.showConfirmModal = true;
    this.closeActionsPanel();
  }

  setSort (key: string) {
    if (key === this.sortBy) {
      this.sortDesc = !this.sortDesc;
    } else {
      this.sortDesc = false;
    }

    this.sortBy = key;
    this.contributionUploadedFileStore.reloadFileList({
      employerId: this.userStore.employerId,
      sortOrder: this.sortOrder
    });
  }

  getSort (key: string) {
    return getSortAttributeValue(key, this.sortBy, this.sortDesc);
  }
}
